import { Field } from 'redux-form';
// import MultiOptionSelect from './OptionSelect';
import MultiSelect from './Multiselect';
import Dropdown from './Dropdown'

const Select = ({id, name, type, typeName, order, multiple, options, required}) => {
  const component = multiple ? MultiSelect : Dropdown;
  return ( 
    <div>
      <Field
        multiple={multiple}
        id={id}
        name={name}
        typeName={typeName}
        order={order}
        values={options}
        required={required}
        component={component}
      />
    </div>
  );
}

export default Select;